'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _minimajs = require('minimajs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The handler template.
 * 
 * @export
 * @class DeepRestHandler
 */
var DeepRestHandler = function () {
    /**
     * Creates an instance of DeepRestHandler.
     * 
     * @param {Plugin} plugin 
     * @memberof DeepRestHandler
     */
    function DeepRestHandler(plugin) {
        (0, _classCallCheck3.default)(this, DeepRestHandler);

        this.plugin = plugin;

        this.handle = this.handle.bind(this);
    }

    /**
     * Handle a REST request: http://locahost:3000/demoPlugin/demo/info
     * 
     * @param {Request} request 
     * @param {Response} response 
     * @memberof DeepRestHandler
     */


    (0, _createClass3.default)(DeepRestHandler, [{
        key: 'handle',
        value: function handle(request, response) {
            response.json({ 'deep': 'Get plugin from sub directory in plugin directory.' });
        }
    }]);
    return DeepRestHandler;
}();

exports.default = DeepRestHandler;
//# sourceMappingURL=DeepRestHandler.js.map